module.exports = __webpack_public_path__ + "static/media/loading.4b7079a5.svg";